import { AlbumBrowser } from '../components/AlbumBrowser'

/**
 * アルバムのダウンロードページ
 */
export function AlbumsPage() {
  return <AlbumBrowser />
}
